<template>
  <div
    class="popup"
    :style="{ visibility: show ? 'unset' : 'hidden' }"
    ref="reqpop"
  >
    <!-- @mouseleave="close"> -->
    <div class="top" v-if="!mobile">
      <div class="title">{{ event.extendedProps.name }}</div>
      <button @click="$emit('edit', { jsEvent, event })">
        <img src="@/assets/images/icons/edit.svg" alt="" />
      </button>
      <button
        @click="$emit('delete', event.id)"
        v-if="event.start > new Date()"
      >
        <img src="@/assets/images/icons/trash.svg" alt="" />
      </button>
      <button class="close" @click="close">
        <img src="@/assets/images/icons/close.svg" alt="" />
      </button>
    </div>
    <div class="mobile-header" v-if="mobile">
      <div class="title">
        Детали записи
      </div>
      <button @click="close">
        <img src="@/assets/images/icons/close.svg" alt="close" />
      </button>
    </div>
    <div class="info">
      <div class="title">{{ event.extendedProps.sum }} Р</div>
      <div class="text">
        {{ $moment(event.start).format("ll") }}
      </div>
      <div class="text" v-if="event.extendedProps.coworking">
        {{ event.extendedProps.coworking.name }}
        ({{ event.extendedProps.coworking.address }})
      </div>
      <div class="status success">рабочее место забронировано</div>
      <!--      <div class="status error" v-if="event.extendedProps.error">Забронировано неподходящее рабочее место</div>-->
      <!--      <div class="rent pointer no-select" v-if="!event.extendedProps.payed && !event.extendedProps.error">Арендовать рабочее место</div>-->
    </div>
    <hr />
    <div class="person" v-if="event.extendedProps.client">
      <img
        v-if="event.extendedProps.client.avatar"
        :src="event.extendedProps.client.avatar"
        width="50px"
        height="50px"
        style="object-fit: cover; border-radius: 50%"
      />
      <div class="person-data">
        <div class="title">{{ event.extendedProps.client.full_name }}</div>
        <div class="phone">{{ event.extendedProps.client.phone }}</div>
      </div>
      <ButtonComponent
        variant="outlined"
        ml="auto"
        :width="mobile ? '100%' : '70px'"
        @click="createConversation(event.extendedProps.client.id)"
      >
        Чат
      </ButtonComponent>
    </div>
    <ButtonComponent
      variant=""
      style="color: #E05252;"
      mb="20px"
      mt="15px"
      v-if="mobile"
      width="100%"
      @click="$emit('delete', event.id)"
    >
      Удалить запись
    </ButtonComponent>
    <ButtonComponent
      variant="filled"
      width="100%"
      @click="$emit('edit', { jsEvent, event })"
    >
      Редактировать
    </ButtonComponent>
  </div>
</template>

<script>
import ButtonComponent from "@/components/ui/buttons/button-component";
import ChatMixin from "@/mixins/chat";

export default {
  name: "detailsWDialog",
  components: { ButtonComponent },
  mixins: [ChatMixin],
  data: () => ({
    show: false,
    jsEvent: null,
    mobile: false,
    event: {
      title: "",
      id: 0,
      extendedProps: {
        price: 0,
        error: false,
        payed: false,
      },
      start: new Date(),
    },
  }),
  methods: {
    open(e) {
      this.clear();
      this.event = e.event;
      this.jsEvent = e.jsEvent;
      if (window.innerWidth < 425) {
        this.mobile = true;
        this.$refs.reqpop.style.left = "0px";
        this.$refs.reqpop.style.bottom = "0px";
      } else {
        this.mobile = false;
        let w = this.$refs.reqpop.offsetWidth;
        let h = this.$refs.reqpop.offsetHeight;
        //offsets section
        let left = Math.abs(
          e.jsEvent.x - e.jsEvent.layerX + e.jsEvent.target.clientWidth + w
        );
        let ofset = 10;
        let lofSet = document.body.clientWidth - left;
        if (lofSet > 0) {
          lofSet = ofset;
        } else {
          lofSet = -e.jsEvent.target.clientWidth - w - ofset;
        }
        left -= 365;
        let scrY = window.scrollY;
        if (
          document.body.offsetHeight <
          e.jsEvent.y - e.jsEvent.layerY + window.scrollY + h
        )
          scrY = -h + e.jsEvent.target.clientHeight + window.scrollY;
        //offsets end
        this.$refs.reqpop.style.left = left + lofSet + "px";
        this.$refs.reqpop.style.top =
          Math.abs(e.jsEvent.y - e.jsEvent.layerY + scrY) + "px";
      }

      this.$emit("opened");
      this.show = true;
    },
    clear() {
      this.event = {
        title: "",
        id: 0,
        extendedProps: {
          price: 0,
          error: false,
          payed: false,
        },
        start: new Date(),
      };
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
hr {
  margin: 15px 0;
  color: #dbbfa7;
  border: none;
  background-color: #dbbfa7;
  height: 1px;
}

.popup {
  position: absolute;
  right: 0;
  top: 500px;
  max-width: 365px;
  width: 100%;
  border: 2px solid #dbbfa7;
  border-radius: 5px;
  background-color: #fff;
  padding: 15px 20px 20px 20px;
  z-index: 500;

  .mobile-header {
    border-radius: 10px 10px 0 0;
    background: #dbbfa7;
    height: 50px;
    position: absolute;
    left: 0;
    right: 0;
    top: -49px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px;

    &.title {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #383838;
    }

    & button {
      background-color: transparent;
      border: none;
      width: 20px;
      height: 20px;

      img {
        max-width: 100%;
      }
    }
  }
}

.title {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #383838;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #808080;
}

.rent {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #b9765b;
}

.status {
  margin-top: 15px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;

  &.success {
    color: #0f8a84;
  }

  &.error {
    color: #e05252;
  }
}

.top {
  display: flex;
  margin-bottom: 15px;

  & .title {
    margin-right: auto;
    font-weight: 600;
  }

  button {
    border: none;
    background-color: transparent;
    margin-left: 10px;
    filter: grayscale(100%);
  }
}

.person {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  img {
    margin-right: 10px;
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
    color: #383838;
  }

  .phone {
    font-size: 14px;
    line-height: 1.7;
    color: #808080;
  }
}

.payed {
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #0f8a84;
  margin-bottom: 15px;
}

.close {
  width: 22px;
  min-width: 22px;
  height: 22px;

  img {
    width: 100%;
  }
}

@media (max-width: 425px) {
  .popup {
    max-width: 100%;
    position: fixed;
    left: 0 !important;
    top: unset !important;
    bottom: 0;
    right: 0;
    border: unset;
  }

  .save {
    width: 100%;
    border-radius: 5px;
    border: unset;
    background-color: #dbbfa7;
    color: #383838;
    margin: 15px auto;
  }
  .person {
    flex-wrap: wrap;
  }
  .person-data {
    width: 80%;
    margin-bottom: 15px;
  }
}
</style>
